import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {ProgressModel} from '../../../services/models/progress.model';
import {ProgressService} from '../../../services/progress.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {LeaderboardService} from '../service/leaderboard.service';
import {LeaderboardModel} from '../models/leaderboard.model';

@Component({
    selector: 'app-leaderboard-hub-page',
    templateUrl: 'leaderboard-hub.page.html',
    styleUrls: ['leaderboard-hub.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class LeaderboardHubPage implements OnInit {

    environment = null;
    menuVisible = true;

    leaderboardData: LeaderboardModel[] = null;
    leaderboardPromise: Promise<LeaderboardModel[]> = null;
    leaderboardValid = false;
    userType = null;

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;
    platform = 'website';

    type = 'hub'; // world, hub, quiz, sim
    name = 'atlanta';

    // '60','Atlanta Sales'
    // '61','Atlanta SE'
    // '62','Prague Sales'
    // '63','Prague SE'
    // '64','Bucharest Sales'
    // '65','Bucharest SE'
    // '66','Yerevan Sales'
    // '67','Yerevan SE'
    // '68','Kuala Lumpur Sales'
    // '69','Kuala Lumpur SE'
    // '70','Virtual Sales'
    // '71','Virtual SE'
    // '72','Atlanta Sales New'
    // '73','Bucharest Sales New'
    // '74','Virtual Sales New'


    hubs = {
        'atlanta': {
            'world': null,
            'hub': [60, 61, 72],
            'sim': [60, 61, 72],
            'quiz': [61],
            'name': 'Atlanta'
        },
        'prague': {
            'world': null,
            'hub': [62, 63],
            'sim': [62, 63],
            'quiz': [63],
            'name': 'Prague'
        },
        'bucharest': {
            'world': null,
            'hub': [64, 65, 73],
            'sim': [64, 65, 73],
            'quiz': [65],
            'name': 'Bucharest'
        },
        'yerevan': {
            'world': null,
            'hub': [66, 67],
            'sim': [66, 67],
            'quiz': [67],
            'name': 'Yerevan'
        },
        'kualalumpur': {
            'world': null,
            'hub': [68, 69],
            'sim': [68, 69],
            'quiz': [69],
            'name': 'Kuala Lumpur'
        },
        'virtual': {
            'world': null,
            'hub': [70, 71, 74],
            'sim': [70, 71, 74],
            'quiz': [71],
            'name': 'Virtual'
        },
    };

    constructor(
        public authService: AuthService,
        private leaderboardService: LeaderboardService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private progressService: ProgressService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.environment = environment;
        setInterval(() => {
            let type = null;
            switch (this.type) {
                case 'world':
                    type = 'hub';
                    break;
                case 'hub':
                    type = 'quiz';
                    break;
                case 'quiz':
                    if (this.name === 'prague' || this.name === 'virtual') {
                        type = 'world';
                    } else {
                        type = 'sim';
                    }
                    break;
                case 'sim':
                    type = 'world';
                    break;
            }

            this.refresh(type);
        },  30 * 1000)
    }

    ngOnInit(): void {
        this.platform = environment.platform;
        this.name = this.route.snapshot.paramMap.get("name");
        if (!this.hubs.hasOwnProperty(this.name)) {
            this.router.navigate(['leaderboard/world'])
        }
        console.log(this.name)
    }


    ionViewWillEnter() {
        this.leaderboardPromise = this.leaderboardService.getLeaderboardWorld(this.hubs[this.name][this.type], this.type);
    }

    ionViewDidEnter() {
        this.analytics.trackView('Hub Leaderboard');

        this.leaderboardPromise.then(data => {
            this.leaderboardData = data;
            this.leaderboardValid = true;
        });
    }

    refresh(type) {
        this.leaderboardService.getLeaderboardWorld(this.hubs[this.name][type], type)
            .then(data => {
                this.type = type;
                this.leaderboardData = data;
                this.leaderboardValid = true;
            });
    }
}
